

import { Injectable } from '@angular/core';
import { AppState } from './app-state';
import { RolePermissionViewService } from './services/role-permission-view.service';


export  class RoleActionPermissions {
    canEditUsers : boolean = false
    canEditTasks : boolean = false
    canSchedule : boolean = false
    canEditPointTests : boolean = false
    canAssignScheduler : boolean = false
    isAdmin : boolean = false
}

@Injectable({
  providedIn: 'root',
})
export class RoleMgr extends RoleActionPermissions {

    constructor( private appState : AppState,
        public rolePermissionViewService: RolePermissionViewService ) {
        super()
        appState.userSubject.subscribe( user => this.assignPermissionsForCurrentUser() )
    }

    assignPermissionsForCurrentUser() {
        const user = this.appState.getUser()
        if ( !user || !user.role ) {
            this.resetPermissions()
        } else {
            const permissions = user.permissions

            if ( !permissions ) {
                this.resetPermissions()
            } else {
                this.assignRoleActionPermissions(this,user.role,permissions)
                console.log(user.email + ' can edit users? ' + this.canEditUsers)
                console.log(user.email + ' can edit tasks? ' + this.canEditTasks)
                console.log(user.email + ' can schedule tasks/scouts ' + this.canSchedule)
                console.log(user.email + ' can edit point tests? ' + this.canEditPointTests)
                console.log(user.email + ' can assign schedulers? ' + this.canAssignScheduler)
            }
        }
    }


    assignRoleActionPermissions( targetObj : Partial<RoleActionPermissions>, 
            roleName: string, srcPermissions: string[] ) : RoleActionPermissions {
        targetObj.isAdmin = roleName == 'admin'
        targetObj.canEditUsers = srcPermissions.includes('edit_users')
        targetObj.canEditTasks = srcPermissions.includes('edit_tasks')
        targetObj.canSchedule = srcPermissions.includes('schedule')
        targetObj.canEditPointTests = srcPermissions.includes('edit_point_tests')
        targetObj.canAssignScheduler = ['admin','pm'].includes(roleName)        
        return targetObj as RoleActionPermissions
    }


    async getRoleActionPermissions( roleId: string ) : Promise<RoleActionPermissions> {
        let userActionPermissions = {}
        if ( !roleId ) {
            throw new Error('roleId required for getRoleActionPermissions')
        }
        const userRole = await this.rolePermissionViewService.getUserRole(roleId)
        return this.assignRoleActionPermissions(userActionPermissions,userRole.id,userRole.permissions)
    }
        
    async getAllRoleActionPermissions() : Promise< { [roleId:string]: RoleActionPermissions} > {
        const userRoles = await this.rolePermissionViewService.getUserRoles()
        let rtn = {}
        userRoles.forEach( userRole => {
            let userActionPermissions = {}
            rtn[userRole.id] = this.assignRoleActionPermissions(userActionPermissions,userRole.id,userRole.permissions)
        })     
        return rtn   
    }

    public clearRoleActionPermissions(rap: RoleActionPermissions) {
        rap.isAdmin = false
        rap.canEditUsers = false
        rap.canEditTasks = false
        rap.canSchedule = false
        rap.canEditPointTests = false
        rap.canSchedule = false
        rap.canAssignScheduler = false
    }

    private resetPermissions() {
        this.clearRoleActionPermissions(this)
    }

}